import React, { useEffect, useRef } from "react";
export function paintInk(canvas, strokes) {
  const context = canvas.getContext("2d");
  context.clearRect(0, 0, canvas.width, canvas.height);
  const colors = {
    red: "#dc2626",
    blue: "#2563eb",
    green: "#15803d",
    yellow: "#d99d00",
    black: "#111827",
  };
  for (const stroke of strokes) {
    context.strokeStyle = colors[stroke.color] || colors.red;
    context.lineWidth = stroke.width * canvas.width;
    context.lineCap = "round";
    context.lineJoin = "round";
    context.beginPath();
    stroke.points.forEach((point, index) => {
      if (index)
        context.lineTo(point.x * canvas.width, point.y * canvas.height);
      else context.moveTo(point.x * canvas.width, point.y * canvas.height);
    });
    context.stroke();
  }
}
export default function AgreementInk({
  strokes,
  onChange,
  page = 0,
  color = "red",
  width = 800,
  height = 1000,
  disabled = false,
  signature = false,
}) {
  const ref = useRef(null),
    current = useRef(null);
  useEffect(() => {
    if (ref.current) paintInk(ref.current, strokes);
  }, [strokes, width, height]);
  const point = (event) => {
    const box = event.currentTarget.getBoundingClientRect();
    return {
      x: Math.max(0, Math.min(1, (event.clientX - box.left) / box.width)),
      y: Math.max(0, Math.min(1, (event.clientY - box.top) / box.height)),
    };
  };
  const finish = (event) => {
    const stroke = current.current;
    if (!stroke) return;
    current.current = null;
    if (stroke.points.length > 1) onChange([...strokes, stroke]);
    else paintInk(ref.current, strokes);
    if (event.currentTarget.hasPointerCapture?.(event.pointerId))
      event.currentTarget.releasePointerCapture(event.pointerId);
  };
  return (
    <canvas
      ref={ref}
      width={width}
      height={height}
      aria-label={
        signature
          ? "Draw your signature"
          : `Draw vehicle condition marks on page ${page + 1}`
      }
      role="img"
      style={{
        width: "100%",
        height: "100%",
        display: "block",
        touchAction: disabled ? "auto" : "none",
        cursor: disabled ? "default" : "crosshair",
      }}
      onPointerDown={(event) => {
        if (disabled || current.current) return;
        event.preventDefault();
        event.currentTarget.setPointerCapture(event.pointerId);
        current.current = {
          page,
          color: signature ? "black" : color,
          width: signature ? 0.004 : 0.003,
          points: [point(event)],
        };
      }}
      onPointerMove={(event) => {
        if (!current.current) return;
        current.current.points.push(point(event));
        paintInk(ref.current, [...strokes, current.current]);
      }}
      onPointerUp={finish}
      onPointerCancel={finish}
    />
  );
}
